import React from 'react';
import wb0 from '../img/Detail/crow_detail.jpg';
import './Detail.css';
const CrowDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default CrowDetail;